import { ReactNode } from 'react';
import { cn } from '@/lib/utils.ts';

export const ToolbarButton = ({
  onClick,
  isActive,
  disabled = false,
  children,
  title,
}: {
  onClick: () => void;
  isActive: boolean;
  disabled?: boolean;
  children: ReactNode;
  title: string;
}) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    disabled={disabled}
    className={cn(
      'flex h-8 w-8 items-center justify-center rounded-md transition',
      disabled
        ? 'cursor-not-allowed text-neutral-300'
        : isActive
          ? 'bg-neutral-100 text-neutral-900'
          : 'text-neutral-500 hover:bg-neutral-50 hover:text-neutral-700',
    )}
  >
    {children}
  </button>
);

export const Separator = () => (
  <div className="mx-1 h-6 w-px bg-neutral-200" />
);

export const ToolbarGroup = ({ children }: { children: ReactNode }) => (
  <div className="flex items-center gap-0.5">{children}</div>
);
